import { api } from './api';
import type { Shipment, ApiResponse, PagedResult, ShipmentStatus, TrackingHistory } from '@/types';

export const shipmentService = {
  getAll: async (page: number = 1, pageSize: number = 20, statusIds?: number[]): Promise<ApiResponse<PagedResult<Shipment>>> => {
    let url = `/api/shipments?page=${page}&pageSize=${pageSize}`;
    if (statusIds && statusIds.length > 0) {
      url += `&statusIds=${statusIds.join(',')}`;
    }
    const response = await api.get(url);
    return response.data;
  },
  getById: async (id: number): Promise<ApiResponse<Shipment>> => {
    const response = await api.get(`/api/shipments/${id}`);
    return response.data;
  },
  getByTracking: async (trackingNumber: string): Promise<ApiResponse<Shipment>> => {
    const response = await api.get(`/api/PublicTracking/track/${trackingNumber}`);
    return response.data;
  },
  create: async (data: Partial<Shipment>): Promise<ApiResponse<Shipment>> => {
    const response = await api.post('/api/shipments', data);
    return response.data;
  },
  update: async (id: number, data: Partial<Shipment>): Promise<ApiResponse<Shipment>> => {
    const response = await api.put(`/api/shipments/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete(`/api/shipments/${id}`);
    return response.data;
  },
  getStatuses: async (): Promise<ApiResponse<ShipmentStatus[]>> => {
const response = await api.get('/api/shipmentstatuses');
    return response.data;
  },
  getTrackingHistory: async (shipmentId: number): Promise<ApiResponse<TrackingHistory[]>> => {
    const response = await api.get(`/api/shipments/${shipmentId}/tracking`);
    return response.data;
  },
bulkUpdateStatus: async (
  shipmentIds: number[],
  statusId: number,
  subStatusId?: number
): Promise<ApiResponse<any>> => {
  const response = await api.put('/api/Shipments/bulk-status', {
    shipmentIds,
    statusId,
    subStatusId: subStatusId || null,
  });

  return response.data;
},  
search: async (query: string, branchId?: number, page: number = 1, pageSize: number = 20): Promise<ApiResponse<PagedResult<Shipment>>> => {
    const params = new URLSearchParams({ query, page: String(page), pageSize: String(pageSize) });
    if (branchId) params.append('branchId', String(branchId));
    const response = await api.get(`/api/shipments/search?${params}`);
    return response.data;
  },
};
